/**
 * LOSEFORD トップページ — 横並びカルーセルの左右ボタン
 *
 * 松本様ご指摘 2026-08-27:
 *   「商品を横に移動できるように、左右のバトン形式を考慮してください」
 *
 * トップの RANKING / NEW ITEMS / JOURNAL は、それぞれテーマ側の作りが違う。
 *   RANKING   … .slider-container が横スクロールする（テーマ独自のスライダー）
 *   NEW ITEMS … .lf-grid--carousel 自身が横スクロールする
 *   JOURNAL   … .grid--uniform 自身が横スクロールする
 * テーマ側の矢印は RANKING にしか無く、見た目も動きもそろわないため、
 * LOSEFORD 所有のボタンを1種類だけ作り、3か所で同じものを使う。
 *
 * 動きは scrollBy に任せる（テーマ側のスライダーの内部状態には触らない）。
 * 指でのスクロールと併用しても位置がずれない。
 *
 * 出す条件は「はみ出しているとき」だけ。PC のように全部収まっている幅では
 * 自動的に消えるので、画面幅ごとの分岐は書かない。
 */
(function () {
  /* 探す場所。左が「囲い（ボタンを置く親）」、右が「実際に横スクロールする箱」 */
  var TARGETS = [
    { host: '.slider-wrapper', scroller: '.slider-container' },
    { host: null, scroller: '.lf-grid--carousel' },
    { host: null, scroller: '.section__blog-posts > .grid--uniform' }
  ];

  var SVG_PREV = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M10 2.5 4.5 8l5.5 5.5" stroke="currentColor" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter"/></svg>';
  var SVG_NEXT = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M6 2.5 11.5 8 6 13.5" stroke="currentColor" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter"/></svg>';

  function isScrollable(el) {
    if (!el) return false;
    var ox = getComputedStyle(el).overflowX;
    return ox === 'auto' || ox === 'scroll';
  }

  function visibleChildren(el) {
    var out = [];
    for (var i = 0; i < el.children.length; i += 1) {
      if (el.children[i].getClientRects().length) out.push(el.children[i]);
    }
    return out;
  }

  /**
   * カードが並んでいる列を探す。
   * RANKING はスクロールする箱（.slider-container）の中に .slider-track が1枚あり、
   * カードはさらにその中にある。1枚しか子が無いときは1段だけ内側を見る。
   */
  function cardRow(scroller) {
    var kids = visibleChildren(scroller);
    if (kids.length === 1) {
      var inner = visibleChildren(kids[0]);
      if (inner.length > 1) return inner;
    }
    return kids;
  }

  /** カード1枚分の送り幅（隣り合うカードの左端の差） */
  function step(scroller) {
    var kids = cardRow(scroller);
    if (kids.length >= 2) {
      var d = kids[1].getBoundingClientRect().left - kids[0].getBoundingClientRect().left;
      if (d > 1) return d;
    }
    if (kids.length === 1) return kids[0].getBoundingClientRect().width;
    return scroller.clientWidth;
  }

  /**
   * ボタンの縦位置を写真の中心に合わせる。
   * カードは写真の下に商品名と価格が続くので、カード全体の中心では低すぎる。
   */
  function alignToPhoto(host, scroller) {
    var hr = host.getBoundingClientRect();
    var sr = scroller.getBoundingClientRect();

    // 左右は「囲い」ではなくスクロールする箱の端から測る。
    // 囲いに page-width の余白が付いていて、カードが画面の端まで伸びている場合は
    // 差が負になる。そのままにしないと余白の分だけ内側へ寄ってしまう。
    host.style.setProperty('--lf-arrow-left', (sr.left - hr.left + 8) + 'px');
    host.style.setProperty('--lf-arrow-right', (hr.right - sr.right + 8) + 'px');

    var img = scroller.querySelector('img');
    if (!img) return;
    var ir = img.getBoundingClientRect();
    if (!ir.height) return;
    host.style.setProperty('--lf-arrow-top', (ir.top - hr.top + ir.height / 2) + 'px');
  }

  function build(scroller, hostSelector) {
    if (!scroller || scroller.hasAttribute('data-lf-arrows-ready')) return;
    if (!isScrollable(scroller)) return;
    scroller.setAttribute('data-lf-arrows-ready', '');

    var host = hostSelector ? scroller.closest(hostSelector) : scroller.parentElement;
    if (!host) host = scroller.parentElement;
    if (!host) return;
    host.classList.add('lf-carousel-host');

    function make(dir, svg, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lf-carousel-arrow lf-carousel-arrow--' + dir;
      b.setAttribute('data-lf-arrow', dir);
      b.setAttribute('aria-label', label);
      b.innerHTML = svg;
      b.addEventListener('click', function () {
        var by = step(scroller) * (dir === 'next' ? 1 : -1);
        scroller.scrollBy({ left: by, behavior: 'smooth' });
      });
      host.appendChild(b);
      return b;
    }

    var prev = make('prev', SVG_PREV, '前の商品を見る');
    var next = make('next', SVG_NEXT, '次の商品を見る');

    function update() {
      var over = scroller.scrollWidth - scroller.clientWidth;
      // はみ出していなければ左右とも出さない（PC ではここで消える）
      host.classList.toggle('lf-carousel-host--on', over > 2);
      prev.disabled = scroller.scrollLeft <= 2;
      next.disabled = scroller.scrollLeft >= over - 2;
      alignToPhoto(host, scroller);
    }

    scroller.addEventListener('scroll', function () {
      // スクロール中に毎回測らない
      window.clearTimeout(scroller._lfArrowTimer);
      scroller._lfArrowTimer = window.setTimeout(update, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      window.clearTimeout(scroller._lfArrowResize);
      scroller._lfArrowResize = window.setTimeout(update, 150);
    });

    // 画像が後から読み込まれると高さが変わるので、そのときも位置を取り直す
    var img = scroller.querySelector('img');
    if (img && !img.complete) img.addEventListener('load', update, { once: true });

    update();
    // 遅れて効くレイアウト（フォント・遅延読み込み）に備えてもう一度
    window.setTimeout(update, 700);
  }

  function start() {
    TARGETS.forEach(function (t) {
      var list = document.querySelectorAll(t.scroller);
      Array.prototype.forEach.call(list, function (el) { build(el, t.host); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // テーマエディタでセクションを描き直したとき / タブを切り替えたときにも効かせる
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('click', function (e) {
    if (e.target.closest('.tab-link, [data-tab]')) window.setTimeout(start, 120);
  });
})();
